<mat-form-field style='width:80%'>
    <mat-label>How many Players in your league/group</mat-label>
    <input matInput placeholder='How many Players in your league/group' [(ngModel)]='calculator.playersInGroup'>
</mat-form-field>
<mat-form-field style='width:80%'>
    <mat-label>How many Events/Year do you play</mat-label>
    <input matInput placeholder='How many Events/Year do you play' [(ngModel)]='calculator.eventsPerYear'>
</mat-form-field>
<mat-form-field style='width:80%'>
    <mat-label>How many Players/Event on average</mat-label>
    <input matInput placeholder='How many Players/Event on average' [(ngModel)]='calculator.playersPerEvent'>
</mat-form-field>
<div *ngIf='match' style='text-align:center'>
    <div>{{match.short_description}}/{{ match.price | currency}}</div>
    <div>
        {{ costPerMember | currency }} per member/year
    </div>
    <div>
        OR
    </div>
    <div>
        {{ costPerEvent | currency}} per member/event
    </div>
    <button mat-raised-button class='orange-button' (click)='joinNow()' *ngIf='!loggedIn'>Join Now</button>
    <button mat-raised-button class='orange-button' (click)='upgrade()' *ngIf='loggedIn'>UPGRADE</button>
    <button mat-raised-button (click)='calculateMatch()' style='color:black'>Try Again <i class='fa fa-spinner fa-spin'
            *ngIf='calculatingMatch'></i></button>
</div>
<button *ngIf='!match' mat-raised-button class='orange-button'
    style='color:white;font-size:18px;width: 190px !important;' (click)='calculateMatch()'>
    FIND MY MATCH
    <i class='fa fa-chevron-circle-right' *ngIf='!calculatingMatch'></i>
    <i class='fa fa-spinner fa-spin' *ngIf='calculatingMatch'></i>
</button>